import DetailM01 from 'features/SpecializeReview/pages/DetaiM01';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function SpecializeReviewDetailM01Page() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <DetailM01 />
      </Layout>
    </LayoutProvider>
  );
}

export default SpecializeReviewDetailM01Page;
